import {
  LowerBar,
  PatientStatusBarContainer,
  UpperBar,
} from "./PatientGroupChatListItem.style";

function PatientStatusBar({ patientStatus }: { patientStatus: number }) {
  return (
    <PatientStatusBarContainer
      data-testid="patient-status"
      sx={{ marginRight: "5px" }}
    >
      <UpperBar status={patientStatus} />
      <LowerBar status={patientStatus} />
    </PatientStatusBarContainer>
  );
}

export default PatientStatusBar;
